import getNewestEntityDate from 'components/data-containers/PerformanceTrend/helpers/getNewestEntityDate';

const getLatestDate = (trends: any): any[] => {
  return trends.reduce(
    (prev: any, trend: any) => [
      ...prev,
      Number(new Date(getNewestEntityDate([trend]))),
    ],
    []
  );
};

export default getLatestDate;
